<template>
  <div class="page-view pt-4">
	  <div class="container">
        <div itemscope itemtype="http://schema.org/Product" class="product-scope">
            <meta itemprop="url" content>
            <meta itemprop="image" content>
            <div class="product_wrap">
                <div class="row detail_top_prd">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-sx-12 product_images">
                        <div class="img_sp">
                            <div class="img_sp img_pdt">
                                <a href id="zoom" class="cloud-zoom" rel="position:'right', adjustX:50, adjustY:-3, tint:'#FFFFFF', softFocus:1, smoothMove:5, tintOpacity:0.8">
                                    <img v-bind:src="getImages(productDetail)" alt="Ngọc Huệ Spa" id="img-detail" style="display:inline !important; width:100%">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="product_name" class="col-lg-6 col-md-6 col-sm-6 col-sx-12">
                        <div itemprop="name" class="product_name">
                            <h1 class="prd-title">{{productDetail.name}}</h1>
                            <hr class="hr1">
                        </div>
    
                        <div id="product_description" class="rte" itemprop="description">
                            <div v-html="parse(productDetail.description)"></div>
                        </div>
                        <div class="price-box clearfix">			
                          <span  v-if="productDetail.price > 0" class="product-price">
                            {{ productDetail.price | currency}}
                            <del class="product-price-old">{{ productDetail.oldPrice | currency}}</del>
                          </span>
                          <span v-else ><router-link exact :to="{  name: 'contact',  params: { slug: 'lien-he' }}">Giá: Liên hệ</router-link></span>
                        </div>
                        <div class="alert alert-info" role="alert">
                            <div style=" font-size: 17px">
                                <b style="color: red">Hỗ trợ mua hàng:</b>
                                <br>
                                <b>Hotline: (028) 225 39 018 - 09 1889 4567</b>
                                <br>
                                <span style="font-size:14px"> (Bán hàng cả Thứ Bảy và Chủ Nhật)</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 pt-4 pb-4">
                      <div class="prd-detail">
                        <div class="tabs-prd-title"><span>Thông tin sản phẩm</span></div>                            
                        <div v-html="parse(productDetail.detail)"></div>                            
                        </div>
                    </div>                    
                    
                    <div class="col-md-12 related-products-wrapper">
                      <div class="tabs-prd-title"><span>Sản phẩm cùng loại</span></div>                        
                      <div class="groups-pdr">                        
                        <RwvProductListItem :products="productsByCategory"> </RwvProductListItem>                        
                      </div>  
                    </div>                    
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import store from "@/store";
import RwvProductListItem from "@/components/ProductListItem";
import { FETCH_PRODUCT_DETAIL } from "@/store/actions.type";
import util from "@/common/util";
export default {
  name: "rwv-product-detail",
  props: {
    
    slug: {
      type: String,
      required: true
    }
  },
  components: {    
    RwvProductListItem
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(FETCH_PRODUCT_DETAIL, to.params.slug)]).then(
      () => {}
    );

    next();
  },
  computed: {
    ...mapGetters(["productDetail", "productsByCategory"])
  },
  methods: {
    parse(body) {
      return body ? util.parseMarkdown(body) : "";
    },
    getImages(data) {
      return util.getImages(data.image);
    }
  },
  watch: {
    $route(to) {
      store.dispatch(FETCH_PRODUCT_DETAIL, to.params.slug);
    }
  }
};
</script>

<style>

</style>
